import React, { useState, useEffect, useRef } from 'react';
import { parseClasses } from '../../lib/ep.js';
import { useKeyEvents } from '../../lib/hooks.js';

import { SquaredButton } from './ActionButton';
import EmailField from './EmailField';
import Input from './Input';
import SaveButton from './SaveButton';
import UrlField from './UrlField';
import Tooltip from './Tooltip.js';

const RETURN_KEY = 13;

const InputWithButton = (props) => {
	const [ value, setValue ] = useState(props?.value ?? ((props.model != undefined && props.model[props.name] != null) ? props.model[props.name] : ''));

	const text_field = useRef(null);
	useEffect(() => {
		if(props.value != undefined && props.value != value) setValue(props.value);
	}, [ props.value ]);

	const execute_on_empty = props?.execute_on_empty ?? false;
	const enable_key_events = props?.enable_key_events ?? true;

	useKeyEvents({
		[RETURN_KEY]:(e) => {
			if(!enable_key_events) return;
			if(props.onKeyAction != undefined && props.onKeyAction.key == 'Enter') return;
			if(text_field.current && !text_field.current.contains(e.target)) return;
			if(e.target.nodeName != 'TEXTAREA' && e.target.nodeName != 'INPUT') return;
			if(!execute_on_empty && (e.target.defaultValue == "" || e.target.defaultValue == " ")) return;
			props.onSubmit(e.target.value);
			setValue("");
		},
	}, 'keyup');

	useEffect(() => {
		setValue(props?.value ?? (props.model != undefined ? props.model[props.name] : ''));
	}, [ props.model ]);

	const change = (k, v) => {
		setValue(v);
		if(props.onChange !== undefined) props.onChange(k, v);
		if(props.change !== undefined) props.change(k, v);
	};

	let classname = props?.classname ?? 'react_field gui_input_with_submit';
	classname = parseClasses(classname, props._groupClass);

	const submitClassname_def = { other:'gui_not_bordered' };
	const submitClassname_cus = props?.submitClass ?? {};
	const submitClassname = Object.assign({}, submitClassname_def, submitClassname_cus);

	const clearClassname_def = { other:'gui_not_bordered' };
	const clearClassname_cus = props?._clearClass ?? {};
	const clearClassname = Object.assign({}, clearClassname_def, clearClassname_cus);

	const input_type = props?.input_type ?? 'input';
	const button_type = props?.button_type ?? 'button';
	
	let Component = false;
	switch(input_type) {
		case 'email':
			Component = EmailField;
			break;

		case 'url':
			Component = UrlField;
			break;

		default:
			Component = Input;
			break;
	}
	
	return (
		<Component
			{...props}
			inputRef={(r) => text_field.current = r}
			value={value}
			change={(k, v) => change(k, v)}
			actions={<>
				{(button_type == 'save') ? (
					<SaveButton
						squared={true}
						color={props?.submitColor ?? 'mainText'}
						tooltip={props?.submitTooltip ? <Tooltip with_icon={false}>{props.submitTooltip}</Tooltip> : null}
						icon={props?.submitIcon ?? 'knk-arrow-r-big'}
						_class={submitClassname}
						onClick={props.onSubmit}
						aria-label="Submit"
					/>
				) : (
					<SquaredButton
						color={props?.submitColor ?? 'mainText'}
						icon={props?.submitIcon ?? 'knk-arrow-r-big'}
						tooltip={props?.submitTooltip ? <Tooltip with_icon={false}>{props.submitTooltip}</Tooltip> : null}
						_class={submitClassname}
						onClick={() => {props.onSubmit(value),  setValue('') }}
						aria-label="Submit"
					/>
				)}

				{(props.onClear != undefined && typeof props.onClear == 'function') && (
					<SquaredButton
						color={props?.clearColor ?? 'red'}
						icon={props?.clearIcon ?? 'knk-off'}
						_class={clearClassname}
						onClick={(k, v) => { change(k, ''); props.onClear();}}
						aria-label="Delete"
					/>
				)}
			</>}
		/>
	)
}

export default InputWithButton;